import { useState, useEffect, useCallback } from 'react';
import { api, MarketplaceCategoryWithEntityCount } from '../../lib/api';

interface UseEntityCategoriesReturn {
  categories: MarketplaceCategoryWithEntityCount[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useEntityCategories(): UseEntityCategoriesReturn {
  const [categories, setCategories] = useState<MarketplaceCategoryWithEntityCount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await api.getMarketplaceCategoriesWithEntityCounts();
      setCategories(result.categories);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load entity categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    loading,
    error,
    refresh: fetchCategories,
  };
}
